import {COLORS} from 'frontend/utils/color_palettes';
import {DistributionAssetProperties} from 'frontend/utils/map/map_asset';

import {AssetMapMarkerData, DefaultMapMarker, IconSize} from './default';

const SWITCH_COLOR = COLORS.NewPrimary.get(40);

export interface SwitchMapMarkerData extends AssetMapMarkerData {
  color?: string;
}

/**
 * Marker represents switch on a map.
 */
export class SwitchMapMarker extends DefaultMapMarker<SwitchMapMarkerData> {
  protected override getDefaultIcon(size: IconSize = IconSize.DEFAULT, opacity = 1): string {
    const properties = this.asset.properties as DistributionAssetProperties;
    if (properties.openSwitch === true) {
      return openedSwitchSVG(size, opacity, this.data?.color ?? SWITCH_COLOR);
    } else if (properties.openSwitch === false) {
      return closedSwitchSVG(size, opacity, this.data?.color ?? SWITCH_COLOR);
    } else {
      return unknownSwitchSVG(size, opacity, this.data?.color ?? SWITCH_COLOR);
    }
  }

  protected override getRaisedIcon(size: IconSize = IconSize.HOVERED, opacity = 1): string | null {
    const properties = this.asset.properties as DistributionAssetProperties;
    if (properties.openSwitch === true) {
      return openedSwitchSVG(size, opacity, this.data?.color ?? SWITCH_COLOR);
    } else if (properties.openSwitch === false) {
      return closedSwitchSVG(size, opacity, this.data?.color ?? SWITCH_COLOR);
    } else {
      return unknownSwitchSVG(size, opacity, this.data?.color ?? SWITCH_COLOR);
    }
  }
}

function openedSwitchSVG(size = 34, opacity = 1, color = SWITCH_COLOR): string {
  return `
  <svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" fill="none" viewBox="0 0 28 28">
    <g opacity="${opacity}">
      <circle cx="14" cy="14" r="13" fill="${color}" stroke="white" stroke-width="2"/>
      <path fill="white" d="M12.8 9.2a1.2 1.2 0 1 0 2.4 0h-2.4Zm0-7.2v7.2h2.4V2h-2.4Z"/>
      <path stroke="white" stroke-width="2.4" d="M14 26v-7.2"/>
      <circle cx="14" cy="17.6" r="1.8" stroke="white" stroke-width="1.2"/>
      <path stroke="white" stroke-linecap="round" stroke-width="2.4" d="m15.8 15.8 3.6-3.6"/>
    </g>
  </svg>
    `;
}

function closedSwitchSVG(size = 34, opacity = 1, color = SWITCH_COLOR): string {
  return `
  <svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" fill="none" viewBox="0 0 28 28">
    <g opacity="${opacity}">
      <circle cx="14" cy="14" r="13" fill="${color}" stroke="white" stroke-width="2"/>
      <path stroke="white" stroke-width="2" d="M14 2v7.2M14 26v-7.2m0-2.4v-4.8"/>
      <circle cx="14" cy="17.6" r="1.8" stroke="white" stroke-width="1.2"/>
      <circle cx="14" cy="10.4" r="1.8" stroke="white" stroke-width="1.2"/>
    </g>
  </svg>
  `;
}

/**
 * Returns an SVG string for an unknown switch icon.
 */
export function unknownSwitchSVG(size = 34, opacity = 1, color = SWITCH_COLOR): string {
  return `
  <svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" fill="none" viewBox="0 0 28 28">
    <g opacity="${opacity}">
      <circle cx="14" cy="14" r="13" fill="${color}" stroke="white" stroke-width="2"/>
      <path fill="white" d="M12.8 9.2a1.2 1.2 0 1 0 2.4 0h-2.4Zm0-7.2v7.2h2.4V2h-2.4Z"/>
      <path stroke="white" stroke-width="2.4" d="M14 26v-7.2"/>
      <circle cx="14" cy="17.6" r="1.8" stroke="white" stroke-width="1.2"/>
      <path stroke="white" stroke-linecap="round" stroke-width="2.4" d="m15.8 15.8 3.6-3.6"/>
    </g>
  </svg>
  `;
}
